<template>
  <ancestryline-modal title="forms.public-client.modal.title" id="modal-public-client-form" :close="false" :closeable="false" :loading="false">
    <form @submit.prevent="save">
      <card class="p-col-12" >
        <coff-input-password v-model="accessCode" label="forms.public-client.modal.access-code" class="p-col-12 p-md-6 p-lg-4" :feedback="false"/>
      </card>

    </form>

    <template #footer>
      <div class="p-ml-auto">
        <Button :label="$t('btn.choose')" @click.prevent="save"/>
      </div>
    </template>

  </ancestryline-modal>
</template>

<script>
import DialogService from "@/business/ModalBusiness";

export default {
  name: "ModalCodeAccess",

  data(){
    return{
      accessCode: null,
    }
  },

  methods:{

    close(){
      DialogService.closeModal(this.accessCode);
    },

    save(){
      DialogService.closeModal(this.accessCode);
    },

  },

}
</script>

<style scoped>

</style>